var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSettingsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.06,8.97l1.24-2.15-.9-1.56h-2.48l-1.79-1.03-1.24-2.15h-1.8l-1.24,2.15-1.78,1.03h-2.48l-.9,1.56,1.24,2.15v2.06s-1.24,2.15-1.24,2.15l.9,1.55h2.48l1.78,1.03,1.24,2.15h1.8l1.24-2.15,1.78-1.03h2.48l.9-1.56-1.24-2.15v-2.06ZM11.1,14.7c-3.52.78-6.58-2.29-5.8-5.8.39-1.77,1.82-3.2,3.6-3.6,3.52-.78,6.58,2.29,5.8,5.8-.39,1.77-1.82,3.2-3.6,3.6Z"
})));
export default SvgSettingsIcon;